export const employeeSkillsActionTypes = {
  ADD_NEW_SKILL_VIEW: "ADD_NEW_SKILL_VIEW",
  ADD_NEW_SKILL_LOADING: "ADD_NEW_SKILL_LOADING",
  FIELDS_STATE_CHANGE: "FIELDS_STATE_CHANGE",
  CANCEL_ADD_SKILL: "CANCEL_ADD_SKILL",
  SKILL_ADD_FAIL: "SKILL_ADD_FAIL",
  SKILL_ADD_SUCCESS: "SKILL_ADD_SUCCESS",
  SKILL_LIST_LOADING: "SKILL_LIST_LOADING",
  SKILL_LIST_LOAD_SUCCESS: "SKILL_LIST_LOAD_SUCCESS",
  SKILL_LIST_LOAD_FAIL: "SKILL_LIST_LOAD_FAIL",
  DELETE_SKILL_LOADING: "DELETE_SKILL_LOADING",
  DELETE_SKILL_SUCCESS: "DELETE_SKILL_SUCCESS",
  DELETE_SKILL_FAIL: "DELETE_SKILL_FAIL",
  EDIT_SKILL_VIEW: "EDIT_SKILL_VIEW",
  CANCEL_EDIT_SKILL: "CANCEL_EDIT_SKILL",
  EDIT_SKILL_LOADING: "EDIT_SKILL_LOADING",
  EDIT_SKILL_SUCCESS: "EDIT_SKILL_SUCCESS",
  EDIT_SKILL_FAIL: "EDIT_SKILL_FAIL",
  SKILL_BY_DEPARTMENT: "SKILL_BY_DEPARTMENT",
  CLEAR_FIELDS: "CLEAR_FIELDS",
  DELETE_SKILL: "DELETE_SKILL",
  IS_EDIT_SKILL: "IS_EDIT_SKILL",
  SKILL_BTN_LOADING: "SKILL_BTN_LOADING",
  SKILL_BTN_DISABLE: "SKILL_BTN_DISABLE"
};
